// resources/js/Pages/HallOfFame/percentiles.js

export const calculatePercentile = (script, allScripts, metric) => {
    const value = getMetricValue(script, metric);
    if (!value || value === 0) return null;
    
    const allValues = allScripts
        .map(s => getMetricValue(s, metric))
        .filter(v => v > 0);
    
    if (allValues.length === 0) return null;
    
    const countLess = allValues.filter(v => v < value).length;
    return Math.round((countLess / allValues.length) * 100);
};

export const getMetricValue = (script, metric) => {
    const { scores } = script;
    
    // Grouped averages
    if (metric === 'overall_avg') {
        return (scores.sl_overall_grade + scores.rating) / 2;
    }
    if (metric === 'structure_avg') {
        return (scores.sl_structure_grade + scores.plotrating + scores.story_forward) / 3;
    }
    if (metric === 'characters_avg') {
        return (scores.sl_characters_grade + scores.charactersrating + scores.character_changes) / 3;
    }
    if (metric === 'conflict_avg') {
        return (scores.sl_conflict_grade + scores.conflict_level + scores.stakes) / 3;
    }
    if (metric === 'emotional_avg') {
        return (scores.sl_ei_grade + scores.emotional_impact + scores.sl_theme_grade) / 3;
    }
    if (metric === 'dialogue_premise_avg') {
        return (scores.dialoguerating + scores.sl_vi_grade + scores.sl_originality_grade + 
                scores.conceptrating + scores.sl_premise_grade) / 5;
    }
    
    // Direct score fields
    return scores[metric] || 0;
};

export const getHighlightClass = (percentile) => {
    if (percentile === null || percentile === undefined) return '';
    if (percentile > 90) return 'highlight-green';
    if (percentile >= 70) return 'highlight-blue';
    return '';
};

export const formatScore = (percentile, rawScore) => {
    if (percentile === null) return 'N/A';
    return `${percentile}% (${rawScore.toFixed(1)})`;
};